import type { TherapistStore } from "@/Modules/Therapist/Store";
import type { TherapistAction } from "@/Modules/Therapist/Models/Ui/Therapist";

import TherapistApiConnector from "@/Services/TherapyApi/Therapists";

class SetTherapistActionActionHandler {
  constructor(
    private readonly therapistStore: TherapistStore,
    private readonly therapistApiConnector = new TherapistApiConnector()
  ) {}

  public async handle(actionKey: TherapistAction) {
    try {
      this.therapistStore.isLoading = true;

      await this.therapistApiConnector.setTherapistAction({ action_key: actionKey });
    } finally {
      this.therapistStore.isLoading = false;
    }
  }
}

export default SetTherapistActionActionHandler;
